/**
 * The normalised shipment vocabulary. Mirrors the Prisma `ShipmentStatus` enum
 * (a test in packages/database keeps them in sync). Browser-safe: no Prisma import.
 */
export const SHIPMENT_STATUSES = [
  'PENDING',
  'IN_TRANSIT',
  'OUT_FOR_DELIVERY',
  'DELIVERED',
  'FAILED_ATTEMPT',
  'EXCEPTION',
  'RETURNED',
  'EXPIRED',
  'UNKNOWN',
] as const;
export type ShipmentStatus = (typeof SHIPMENT_STATUSES)[number];

/** No further carrier updates are expected. Polling stops. */
export const TERMINAL_SHIPMENT_STATUSES: readonly ShipmentStatus[] = [
  'DELIVERED',
  'RETURNED',
  'EXPIRED',
];

/** Statuses a merchant should look at. */
export const ATTENTION_SHIPMENT_STATUSES: readonly ShipmentStatus[] = [
  'FAILED_ATTEMPT',
  'EXCEPTION',
];

export const SHIPMENT_STATUS_LABELS: Record<ShipmentStatus, string> = {
  PENDING: 'Label created',
  IN_TRANSIT: 'In transit',
  OUT_FOR_DELIVERY: 'Out for delivery',
  DELIVERED: 'Delivered',
  FAILED_ATTEMPT: 'Delivery attempted',
  EXCEPTION: 'Delivery exception',
  RETURNED: 'Returned to sender',
  EXPIRED: 'No recent updates',
  UNKNOWN: 'Status unavailable',
};

export function isTerminalStatus(status: ShipmentStatus): boolean {
  return TERMINAL_SHIPMENT_STATUSES.includes(status);
}

export const ORDER_STATUSES = [
  'CONFIRMED',
  'PARTIALLY_SHIPPED',
  'SHIPPED',
  'DELIVERED',
  'CANCELLED',
] as const;
export type OrderStatus = (typeof ORDER_STATUSES)[number];

export const TRACKING_STATES = ['ACTIVE', 'PAUSED_LIMIT', 'UNSUPPORTED', 'STOPPED'] as const;
export type TrackingState = (typeof TRACKING_STATES)[number];
